// extracted by mini-css-extract-plugin
export default {"templateWrapper":"UserSavedListsTablePage_templateWrapper__pjJgS","pageContainer":"UserSavedListsTablePage_pageContainer__vOJeh"};